@use "../../../sass/variables/colors";

.chat-item-container {
  display: flex;
  gap: 15px;
  width: fit-content;
  max-width: 75%;
  opacity: 0;
  transform: translateY(10px);
  animation: slideIn 0.4s ease forwards;
}

@keyframes slideIn {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.message-content {
  padding: 12px 14px;
  ux-copy {
    font-size: 14px;
    margin: 0;
  }
}

ux-chat-item[source="bot"] {
  display: block;
  .message-content {
    background-color: colors.$color-blue-4;
  }
}

ux-chat-item[source="user"] {
  .message-content {
    background-color: colors.$color-white;
  }
  .chat-item-container {
    margin-left: auto;
  }
}

ux-chat-item[source="system"] {
  .message-content {
    background-color: colors.$color-black-70;
    --ux-button-bg-color: #{colors.$color-white};

    ux-copy + ux-button {
      margin-top: 10px;
    }
  }
}

header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
}

.profile-picture {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  border-radius: 4px;
  background-color: colors.$color-blue-info;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: flex-start;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.user-message-footer {
  text-align: right;
}

.chat-name,
.chat-date {
  color: colors.$color-black-solid;
  font-size: 0.625rem;
}

@media (max-width: 768px) {
  #feedback-button {
    width: 100%;
  }
}
